import React from 'react'
import LoginContent from './LoginContent'

const Login = () => {
  return (
    <div>
        
        <LoginContent />

    </div>
  )
}

export default Login